module.exports = __webpack_public_path__ + "static/media/LokiFrame90.3e263cf8.png";